module.exports = __webpack_public_path__ + "static/juliet-Fun-266c94e440e8c30576bd77a2e10d04d8.jpg";